import { initializeApp } from "firebase/app";
import { getAnalytics, Analytics, isSupported } from "firebase/analytics";
import { logger } from "./logger";
import { env } from "@/config/env";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: env.VITE_FIREBASE_API_KEY,
  authDomain: env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: env.VITE_FIREBASE_APP_ID,
  measurementId: env.VITE_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Runtime Audit - Helping identify environment leakage
if (import.meta.env.DEV || typeof window !== 'undefined') {
  logger?.info?.(`Firebase initialized for project: ${firebaseConfig.projectId}`);
}

// Initialize Analytics only in production or if explicitly enabled
let analytics: Analytics | null = null;

// Use isSupported() to prevent warnings in unsupported environments (like Vitest/Node)
isSupported().then((supported) => {
  if (supported && typeof window !== "undefined") {
    try {
      analytics = getAnalytics(app);

      // Enable debug_mode in development to see events in Firebase DebugView
      if (import.meta.env.DEV && firebaseConfig.measurementId) {
        // Use the native gtag config to force debug_mode
        interface GTag {
          (command: 'config', targetId: string, config?: Record<string, unknown>): void;
          (command: 'set', targetId: string, config?: Record<string, unknown>): void;
          (command: 'event', eventName: string, eventParams?: Record<string, unknown>): void;
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const gtag = (window as any).gtag as GTag | undefined;
        gtag?.('config', firebaseConfig.measurementId, {
          'debug_mode': true
        });
        logger.info("Firebase Analytics debug_mode requested via gtag");
      }
    } catch (error) {
      logger.warn("Firebase Analytics failed to initialize", error);
    }
  }
});

export { analytics };
